module.exports = __webpack_public_path__ + "img/e_3_5_g.969ba0c6.png";